const Home = () => (
  <div className="container-fluid px-0">

    {/* Hero */}
    <div className="hero-wrap">
      <img src="./../images/career-banner.png" alt="Banner" />
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-title">From Healthcare to Tech</div>
        <p className="hero-subtitle">Bridging clinical expertise with software engineering</p>
      </div>
    </div>

    <div className="container mb-5">

      {/* Transferable Skills */}
      <section className="mb-5">
        <h2 className="section-title centered">Transferable Skills</h2>
        <div className="row justify-content-center g-4">

          <div className="col-md-5">
            <div className="skill-card h-100">
              <img
                src="/images/ventilator.png"
                alt="Ventilator"
                style={{ width: "100%", height: "220px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <span className="skill-badge">Healthcare</span>
                <h5 className="fw-bold mb-3">Old Career — Respiratory Therapist</h5>
                <p className="card-text text-muted small mb-2">
                  <strong>Hard Skills:</strong> Operating medical devices, interpreting blood gasses and tests,
                  working with protocols and documentation, and troubleshooting errors, alarms, and equipment malfunctions.
                </p>
                <p className="card-text text-muted small mb-2">
                  <strong>Soft Skills:</strong> Critical thinking, teamwork with multidisciplines, clear communications
                  and adaptability, attention to detail and time management to complete critical tasks.
                </p>
                <p className="card-text text-muted small mb-0">
                  <strong>Additional:</strong> Developing care plans, tracking and monitoring patient care to guide
                  and direct clinical decisions.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-5">
            <div className="skill-card h-100">
              <img
                src="/images/laptop.png"
                alt="Laptop"
                style={{ width: "100%", height: "220px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <span className="skill-badge">Engineering</span>
                <h5 className="fw-bold mb-3">New Career — Software Engineer</h5>
                <p className="card-text text-muted small mb-2">
                  <strong>Hard Skills:</strong> Learning and configuring sophisticated tools, interpreting data
                  and debugging complex code, following software development standards and best practices.
                </p>
                <p className="card-text text-muted small mb-2">
                  <strong>Soft Skills:</strong> Analyzing problems quickly, making sound decisions, collaboration
                  with cross-functional teams, explaining technical concepts and adapting to shifting project requirements.
                </p>
                <p className="card-text text-muted small mb-0">
                  <strong>Additional:</strong> Writing technical documentation, analytics and performance,
                  and improving inefficiencies in software applications.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Quote */}
      <div className="quote-box my-5 mx-auto" style={{ maxWidth: "860px" }}>
        My background as a Respiratory Therapist and years of working in high‑stakes clinical environments taught
        me to think critically under pressure, follow precise protocols, and troubleshoot complex systems in real time.
        I understand how technology impacts real people in mission‑critical settings — allowing me to bridge the gap
        between technical innovation and practical, life‑changing application.
      </div>

      {/* Profile */}
      <div className="row align-items-center g-4 py-3">
        <div className="col-md-5 text-center">
          <img
            src="./../images/profile.png"
            alt="Profile"
            className="profile-img"
            style={{ maxHeight: "420px", objectFit: "cover", width: "80%" }}
          />
        </div>
        <div className="col-md-7">
          <h2 className="fw-bold mb-3" style={{ lineHeight: 1.25 }}>
            Hi, I'm{" "}
            <span style={{ color: "var(--brand)" }}>Isaac Mills-Owoo</span>
            {" "}— developing as a Software Engineer.
          </h2>
          <p className="lead" style={{ color: "var(--text-muted)", lineHeight: 1.75, fontSize: "1.05rem" }}>
            After over a decade as a Respiratory Therapist, I've developed a problem‑solving mindset to create
            meaningful impact where science meets real‑world improvement — delivering solutions that improve lives
            and advance innovation.
          </p>
        </div>
      </div>

    </div>
  </div>
);

export default Home;
